import axios from 'axios';

export const getAllOffers = async () => {
    const url = `/api/v1/user_profile/offer/apartment_offers`;
    const res = await axios.get(url);
    return res.data;
};

export const createOffer = async (offer) => {
    const url = `/api/v1/user_profile/offer/apartment_offers`;
    const res = await axios.post(url, offer);
    return res.data;
};

export const updateOffer = async (id, offer) => {
    const url = `/api/v1/user_profile/offer/apartment_offers/${id}`;
    const res = await axios.patch(url, offer);
    return res.data;
};

export const deleteOffer = async (id) => {
    const url = `/api/v1/user_profile/offer/apartment_offers/${id}`;
    const res = await axios.delete(url);
    return res.data;
};

export const getAllHomes = async () => {
    const url = `/api/v1/user_profile/offer/homes`;
    const res = await axios.get(url);
    return res.data;
}